import {
  AUTH_TOKEN,
  AUTHENTICATED,
  HIDE_AUTH_MESSAGE,
  SHOW_AUTH_MESSAGE,
  SIGNOUT_SUCCESS,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
  STORE_PERMISSIONS,
} from "../constants/Auth";

export const AuthStatus = {
  IDLE: "idle",
  SIGNED_IN: "signedIn",
  SIGNED_OUT: "signedOut",
}

const authToken = localStorage.getItem(AUTH_TOKEN);

const initState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: authToken,
  error: false,
  permissions: [],
  status: authToken ? AuthStatus.SIGNED_IN : AuthStatus.IDLE
};

const auth = (state = initState, action) => {
  switch (action.type) {
    case AUTHENTICATED:
      return {
        ...state,
        loading: false,
        redirect: "/",
        token: action.token,
        status: AuthStatus.SIGNED_IN
      };
    case SHOW_AUTH_MESSAGE:
      return {
        ...state,
        message: action.message,
        showMessage: true,
        loading: false,
        error: action.error,
      };
    case HIDE_AUTH_MESSAGE:
      return {
        ...state,
        message: "",
        showMessage: false,
      };
    case SIGNOUT_SUCCESS: {
      return {
        ...state,
        token: null,
        redirect: "/",
        loading: false,
        status: AuthStatus.SIGNED_OUT
      };
    }
    case SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        token: action.token,
      };
    }
    case SHOW_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case STORE_PERMISSIONS: {
      return {
        ...state,
        permissions: action.permissions,
      };
    }
    default:
      return state;
  }
};

export default auth;
